// 다이어트 플래그(Veg/GF/Spicy) 색상·라벨 — 리스트(shop)·상세(menu) 공용 단일 소스.
// 칩의 크기(padding/radius/font)는 화면별로 다를 수 있으나, 색/라벨은 여기 하나로 관리한다.
export const FLAG_STYLES = {
    veg: { label: "Veg", color: "#2e8b57", bg: "rgba(46,139,87,0.12)" },
    gf: { label: "GF", color: "#b3803a", bg: "rgba(179,128,58,0.14)" },   // 기존 오타 필드명(gluetenFree)과 무관, 표시 키
    spicy: { label: "Spicy", color: "#d64545", bg: "rgba(214,69,69,0.13)" },
} as const;

export type FlagKey = keyof typeof FLAG_STYLES;
